





























import { Vue, Component } from 'vue-property-decorator';
import Modal from '@/components/widgets/molecules/Modal/Modal.vue';
import Table from '@/components/widgets/organisms/Table/Table.vue';
import ButtonCustom from '@/components/widgets/atoms/ButtonCustom/ButtonCustom.vue';

import { SELECT_TRAVEL_INTERRUPTION } from '@/store/travels/actions';

@Component({
	components: {
		Modal,
		Table,
		ButtonCustom,
	},
})
export default class TravelInterruptionModal extends Vue {
	/* Data */
	private isLoading: boolean = false;

	private pedido: string = '';

	private motivoAbortoViagem: string | null = null;

	/* Computed */
	get showModal() {
		return this.$store.getters.hasSelectedTravelInterruption;
	}

	get selectedInterruption() {
		return this.$store.getters.getSelectedTravelInterruption;
	}

	/* Methods */
	resetInfo() {
		this.$store.dispatch(SELECT_TRAVEL_INTERRUPTION, null);
	}

	initInfo() {
		this.isLoading = true;

		this.pedido = this.selectedInterruption.pedido || this.selectedInterruption.customId || '';

		this.motivoAbortoViagem =
			this.selectedInterruption.motivoAbortoViagem || 'Motivo não encontrado';

		this.isLoading = false;
	}

	close() {
		this.$bvModal.hide('TravelInterruptionModal');
	}
}
